<div class="section loose">
  <div class="app-column-auto gapped loose">
    <h1 class="centered">SysPromptHub</h1>
    @for ($option of loginOptions; track $option) {
      <button
        type="button"
        class="large bordered"
        (click)="loginWith($option)"
      >
        Continue with {{$option.name}}
      </button>
    }
  </div>
</div>
